var map = {
	"./additionalInfoIcon.svg": 619,
	"./arrowLeftIcon.svg": 620,
	"./arrowMediumTop.svg": 621,
	"./arrowRightIcon.svg": 622,
	"./arrowRightIconSharp.svg": 623,
	"./arrowRightSmallIcon.svg": 624,
	"./arrowScalableIcon.svg": 625,
	"./arrowSelect2.svg": 626,
	"./arrowSelectIcon.svg": 627,
	"./benefit1.svg": 628,
	"./benefit2.svg": 629,
	"./benefit3.svg": 630,
	"./cardsIcon.svg": 631,
	"./checkCirсleIcon.svg": 632,
	"./circleInfoIcon.svg": 633,
	"./copyIcon copy.svg": 634,
	"./copyIcon.svg": 635,
	"./crossIcon.svg": 636,
	"./crossIcon2.svg": 637,
	"./crossIcon3.svg": 638,
	"./crossIconSmall.svg": 639,
	"./crossSmallIcon.svg": 640,
	"./defaultCategoryIcon.svg": 641,
	"./depNumberIcon.svg": 642,
	"./elfCentralIcon.svg": 643,
	"./equalitySign.svg": 644,
	"./errorIcon.svg": 645,
	"./eyeClosedIcon.svg": 646,
	"./eyeOpenIcon.svg": 647,
	"./favoritesIcon.svg": 648,
	"./favoritesLabelIcon.svg": 649,
	"./filterDivider.svg": 650,
	"./filterIcon.svg": 651,
	"./frequencyIcon.svg": 652,
	"./fsAmountIcon.svg": 653,
	"./fullScreenIcon.svg": 654,
	"./gameIcon.svg": 655,
	"./goldGiftIcon.svg": 656,
	"./hamburgerIcon.svg": 657,
	"./infoIcon.svg": 658,
	"./infoSymbol.svg": 659,
	"./levelBackground.svg": 660,
	"./levelBackgroundNew.svg": 661,
	"./linkIcon.svg": 662,
	"./lockIcon.svg": 663,
	"./lockSharpIcon.svg": 664,
	"./maxBonusAmountIcon.svg": 665,
	"./maxWinFsIcon.svg": 666,
	"./menu/fortuneIcon.svg": 383,
	"./menu/fortuneIconL.svg": 384,
	"./menu/helpdeskIcon.svg": 385,
	"./menu/helpdeskIconL.svg": 386,
	"./menu/homeIcon.svg": 387,
	"./menu/homeIconLarge.svg": 388,
	"./menu/jackpotIcon.svg": 389,
	"./menu/logo.svg": 390,
	"./menu/logoSmall.svg": 391,
	"./menu/loyaltyIcon.svg": 392,
	"./menu/mobileAppIcon.svg": 393,
	"./menu/profileIcon.svg": 394,
	"./menu/questIcon.svg": 395,
	"./menu/questsIcon.svg": 396,
	"./menu/rewardLineupIcon.svg": 397,
	"./menu/searchIcon.svg": 398,
	"./menu/searchIconLarge.svg": 399,
	"./menu/signOutIcon.svg": 400,
	"./menu/star.svg": 401,
	"./menu/tournamentIcon.svg": 402,
	"./menu/tournamentLargeIcon.svg": 403,
	"./menu/vipIcon.svg": 404,
	"./menu/wheelIcon.svg": 405,
	"./menu/wheelIconL.svg": 406,
	"./menu/wheelIconMobile.svg": 407,
	"./menuIcon.svg": 667,
	"./minDepIcon.svg": 668,
	"./noTournamentIcon.svg": 669,
	"./numbers/number-1.svg": 408,
	"./numbers/number-2.svg": 409,
	"./numbers/number-3.svg": 410,
	"./numbers/number-4.svg": 411,
	"./numbers/number-5.svg": 412,
	"./numbers/number-6.svg": 413,
	"./numbers/number-7.svg": 414,
	"./numbers/number-8.svg": 415,
	"./numbers/number-9.svg": 416,
	"./numbers/number-shine-1.svg": 417,
	"./numbers/number-shine-2.svg": 418,
	"./numbers/number-shine-3.svg": 419,
	"./numbers/number-shine-4.svg": 420,
	"./numbers/number-shine-5.svg": 421,
	"./numbers/number-shine-6.svg": 422,
	"./numbers/number-shine-7.svg": 423,
	"./numbers/number-shine-8.svg": 424,
	"./numbers/number-shine-9.svg": 425,
	"./playIcon.svg": 670,
	"./polygon.svg": 671,
	"./preloaderDotsAnimation.svg": 672,
	"./preloaderSpinnerAnimation.svg": 673,
	"./presentIcon.svg": 674,
	"./promoIcon.svg": 675,
	"./recentIcon.svg": 676,
	"./search2Icon.svg": 677,
	"./search3Icon.svg": 678,
	"./sharpTickIcon copy.svg": 679,
	"./sharpTickIcon.svg": 680,
	"./smallInfoSymbol.svg": 681,
	"./smoothArrowIcon.svg": 682,
	"./successIcon.svg": 683,
	"./supportIcon.svg": 684,
	"./tag1Icon.svg": 685,
	"./tag2Icon.svg": 686,
	"./tag3Icon.svg": 687,
	"./tag4Icon.svg": 688,
	"./tickIcon.svg": 689,
	"./unverified.svg": 690,
	"./verified.svg": 691,
	"./wagerIcon.svg": 692,
	"./wagerTimeIcon.svg": 693,
	"./warningIcon.svg": 694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 618;